import VisitorAgreementUI from './VisitorAgreementUI';

export default VisitorAgreementUI;
